<script>
import defineAbilitiesFor from "@/config/abilities";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { INITIAL_EVENTS, createEventId } from "./event-utils";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import TimezoneAutocomplete from "@/components/autocomplete/TimezoneAutocomplete.vue";
import moduleCalendarManagement from "@/store/calendar-management/moduleCalendarManagement.js";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    TimezoneAutocomplete,
    flatPickr,
    quillEditor
  },
  data: function() {
    return {
      abilities: null,
      added_all_day_checkbox: false,
      updated_all_day_checkbox: false,
      event_resize_or_drop: false,
      UpdateEventPopupActive: false,
      updateSelectedInfo: {},
      update_event_title: null,
      update_event_description: null,
      update_event_start: null,
      update_event_end: null,
      selectInfo: {},
      new_event_title: null,
      new_event_description: null,
      new_event_start: null,
      new_event_end: null,
      configdateTimePicker: {
        enableTime: true,
        // dateFormat: "Y-m-d H:i",
        format: "d/m/Y H:i",
        altFormat: "d/m/Y H:i",
        altInput: true
      },
      newEventPopupActive: false,
      new_events: [],
      userEvents: [],
      user_id: null,
      calendarOptions: {
        eventDrop: this.eventDrop,
        eventResize: this.eventResize,
        timeZone: "Pacific/Wake",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay"
        },
        allDaySlot: true,
        initialView: "dayGridMonth",
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        events: []
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      defaultSettings: [],
      scheduleAvailabilities: [],
      user_id: null,
    user_role: null,
    };
  },
  created() {
      var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule(
        "calendarManagement",
        moduleCalendarManagement
      );
      moduleCalendarManagement.isRegistered = true;
    }

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];

    this.user_role = userInfo["userRole"];

if (this.user_role == 'Client Administrator' && this.user_role == 'Client'){
  this.$router.replace("/unauthorized")
}
    
  },
  mounted() {
    // this.fetchDefaultSettings();
    this.fetchScheduleAvailabilites();
    this.fetchEvents();
  },
  methods: {
    handleTimeZoneSelected() {
      var selected_time_zone =
        moduleElomarkUserManagement.state.selected_time_zone;
      this.timeZone = selected_time_zone.name.split(" ")[0];
      // console.log(this.timeZone)
    },
    getTimezones(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getTimezones", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_time_zone;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].label
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
    },
    eventResize(event) {
      console.log(event);
      this.updateSelectedInfo = event;
      this.event_resize_or_drop = true;
      this.fetchEventsByIdFromDB(event.event.id);
    },
    eventDrop(event) {
      console.log(event);

      this.updateSelectedInfo = event;
      this.event_resize_or_drop = true;
      this.fetchEventsByIdFromDB(event.event.id);
    },
    handleDateSelect(selectInfo) {
      this.selectInfo = selectInfo;
      this.newEventPopupActive = true;
      // let title = prompt("Please enter a new title for your event");

      this.new_event_start = moment(this.selectInfo.startStr).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      if (this.selectInfo.allDay) {
        this.added_all_day_checkbox = true;
      } else {
        this.added_all_day_checkbox = false;
      }
      this.new_event_end = moment(this.selectInfo.endStr).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    deleteEvent() {
      this.UpdateEventPopupActive = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete this event "${this.updateSelectedInfo.event.title}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      this.deleteEventsFromDB(this.updateSelectedInfo.event.id);
      this.updateSelectedInfo.event.remove();
    },
    handleEventClick(clickInfo) {
      this.updateSelectedInfo = clickInfo;
      this.fetchEventsByIdFromDB(clickInfo.event.id);
    },
    fetchEventsByIdFromDB(eventId) {
      if (eventId == "") {
        this.$vs.dialog({
          color: "danger",
          title: `Default Settings`,
          text: `You are not allowed to update default settings from here.The changes will be reverted.`
        });
        return;
      }
      this.$store
        .dispatch("calendarManagement/fetchEvent", eventId)
        .then(res => {
          let event = res.data;
          if (event != null) {
            if (this.event_resize_or_drop == true) {
              this.update_event_start = moment(
                this.updateSelectedInfo.event.startStr
              ).format("YYYY-MM-DD HH:mm:ss");

              if (this.updateSelectedInfo.event.allDay == true) {
                this.updated_all_day_checkbox = true;
              } else {
                if (this.updateSelectedInfo.event.endStr == "") {
                  this.update_event_end = this.updateSelectedInfo.event.startStr;
                } else {
                  this.update_event_end = moment(
                    this.updateSelectedInfo.event.endStr
                  ).format("YYYY-MM-DD HH:mm:ss");
                }
                this.updated_all_day_checkbox = false;
              }

              this.allDay = this.updateSelectedInfo.event.allDay;
            } else {
              this.update_event_start = event.start;

              if (this.updateSelectedInfo.event.allDay == true) {
                this.updated_all_day_checkbox = true;
                this.update_event_end = event.start;
              } else {
                this.updated_all_day_checkbox = false;
                this.update_event_end = event.end;
              }
            }
            this.allDay = event.allDay;
            this.update_event_title = event.title;
            this.update_event_description = event.description;
            this.UpdateEventPopupActive = true;
          } else {
            this.$vs.dialog({
              color: "danger",
              title: `Default Settings`,
          text: `You are not allowed to update default settings from here.The changes will be reverted.`
            });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    deleteEventsFromDB(eventId) {
      this.$store
        .dispatch("calendarManagement/deleteEvent", eventId)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Delete Event",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Delete Event",
              text: res.data.message
            });
          }
          this.$router.push("/calendar");
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    addEventsToDB(newEvents) {
      this.$store
        .dispatch("calendarManagement/addEvents", newEvents)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Add Event",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Add Events",
              text: res.data.message
            });
            this.new_event_start = null;
            this.new_event_end = null;
            this.selectInfo.allDay = null;
            this.new_event_title = null;
            this.new_event_description = null;
            this.className = null;
          }
          this.newEventPopupActive = false;
          this.refreshEvents();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    refreshEvents() {
      this.$refs.calendar.$emit("rerender-events");
    },
    updateEventToDB(event) {
      this.$store
        .dispatch("calendarManagement/updateEvent", event)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Update Event",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Update Event",
              text: res.data.message
            });
            this.update_event_start = null;
            this.update_event_end = null;
            this.update_event_title = null;
            this.update_event_description = null;
            this.user_id = null;
            this.className = null;
            this.event_resize_or_drop = false;
          }
          // this.$router.go("/calendar");
          this.UpdateEventPopupActive = false;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    updatedAllDay() {
      this.updated_all_day_checkbox = !this.updated_all_day_checkbox;
    },
    addedAllDay() {
      this.added_all_day_checkbox = !this.added_all_day_checkbox;
    },
    validateBeforeSubmit() {
      let self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          if (self.new_event_title != null) {
            let calendarApi = self.selectInfo.view.calendar;
            calendarApi.unselect(); // clear date selection

            calendarApi.addEvent({
              id: createEventId(),
              title: self.new_event_title,
              start: moment(this.new_event_start)
                .utcOffset(0, true)
                .format()
                .replace("Z", ""),
              end: moment(this.new_event_end)
                .utcOffset(0, true)
                .format()
                .replace("Z", ""),
              description: self.new_event_description,
              allDay: self.selectInfo.allDay
            });

            let newEventObj = {};
            newEventObj.id = createEventId();
            newEventObj.start = this.new_event_start;
            newEventObj.end = this.new_event_end;
            newEventObj.allDay = self.selectInfo.allDay;
            if (self.selectInfo.allDay) {
              newEventObj.end = this.new_event_start;
            } else {
              newEventObj.end = this.new_event_end;
            }
            newEventObj.title = self.new_event_title;
            newEventObj.description = self.new_event_description;
            newEventObj.user_id = self.user_id;
            newEventObj.className = "scheduled";
            self.addEventsToDB(newEventObj);
          }
        } else {
          // form have errors
        }
      });
    },
    validateBeforeUpdate() {
      if (this.update_event_title != null) {
        this.updateSelectedInfo.event.remove();
        let calendarApi = this.updateSelectedInfo.view.calendar;
        calendarApi.unselect(); // clear date selection
        let end_date;
        if (!this.updated_all_day_checkbox) {
          end_date = moment(this.update_event_end)
            .utcOffset(0, true)
            .format()
            .replace("Z", "");
        } else {
          end_date = moment(this.update_event_start)
            .utcOffset(0, true)
            .format()
            .replace("Z", "");
        }
        calendarApi.addEvent({
          id: this.updateSelectedInfo.event.id,
          title: this.update_event_title,
          start: moment(this.update_event_start)
            .utcOffset(0, true)
            .format()
            .replace("Z", ""),
          end: end_date,
          description: this.update_event_description,
          allDay: this.updated_all_day_checkbox
        });

        let updateEventObj = {};
        updateEventObj.id = this.updateSelectedInfo.event.id;
        updateEventObj.start = this.update_event_start;

        updateEventObj.allDay = this.updated_all_day_checkbox;
        if (updateEventObj.allDay == true) {
          updateEventObj.end = null;
        } else {
          updateEventObj.end = this.update_event_end;
        }
        updateEventObj.title = this.update_event_title;
        updateEventObj.description = this.update_event_description;
        updateEventObj.user_id = this.user_id;
        updateEventObj.className = "scheduled";
        this.updateEventToDB(updateEventObj);
      }
    },
    // fetchDefaultSettings() {
    //   this.$store
    //     .dispatch("calendarManagement/fetchAllDefaultSettings", this.user_id)
    //     .then(res => {
    //       if (res) {
    //         if (res.data != null) {
    //           this.defaultSettings = res.data;
    //           var self = this;
    //           this.defaultSettings.forEach(function(defaultEvent) {
    //             let eventsObj = {};
    //             eventsObj.startRecur = defaultEvent.dow;
    //             eventsObj.daysOfWeek = defaultEvent.dow.split(",");
    //             eventsObj.startRecur = moment(defaultEvent.rangeStart).format(
    //               "YYYY-MM-DD"
    //             );
    //             eventsObj.endRecur = moment(defaultEvent.rangeEnd).format(
    //               "YYYY-MM-DD"
    //             );
    //             eventsObj.startTime = defaultEvent.start_time;
    //             eventsObj.endTime = defaultEvent.end_time;
    //             if (defaultEvent.available == true) {
    //               eventsObj.title = "Available";
    //               eventsObj.className = "available";
    //             } else {
    //               eventsObj.title = "Not Available";
    //               eventsObj.className = "not-available";
    //             }
    //             self.calendarOptions.events.push(eventsObj);
    //           });
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if (err.response.status === 404) {
    //         console.log(err);
    //       }
    //       console.error(err);
    //     });
    // },
    fetchScheduleAvailabilites() {
      this.$store
        .dispatch("calendarManagement/fetchScheduleAvailabilites", this.user_id)
        .then(res => {
          if (res) {
            if (res.data != null) {
              this.scheduleAvailabilities = res.data;
              console.log("Schedule Availabilties", res.data);
              var self = this;
              this.scheduleAvailabilities.forEach(function(defaultEvent) {
                    let eventsObj = {};
                   eventsObj.start = defaultEvent.start_date + " " + defaultEvent.start_time;
                  eventsObj.end = defaultEvent.end_date + " " + defaultEvent.end_time;
                  eventsObj.allDay = defaultEvent.allDay
                  if (defaultEvent.available == true) {
                    eventsObj.title = "Available";
                    eventsObj.className = "available";
                  } else {
                    eventsObj.title = "Not Available";
                    eventsObj.className = "not-available";
                  }
                  self.calendarOptions.events.push(eventsObj);
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 404) {
            console.log(err);
          }
          console.error(err);
        });
    },
    fetchEvents() {
      this.$store
        .dispatch("calendarManagement/fetchUserEvents", this.user_id)
        .then(res => {
          if (res) {
            let self = this;
            self.userEvents = res.data;
            self.userEvents.forEach(element => {
              self.calendarOptions.events.push(element);
            });
            console.log(this.userEvents);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userEvents = true;
            return;
          }
          console.error(err);
        });
    }
  }
};
</script>

<template>
  <div class="demo-app">
    <form>
      <vs-popup
        fullscreen
        class="holamundo"
        title="Update Event"
        :active.sync="UpdateEventPopupActive"
      >
        <form>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="update_event_title" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Start</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr class="flat-pick"
                :config="configdateTimePicker"
                v-model="update_event_start"
                placeholder="Date Time"
              />
              <span class="ml-5">All Day</span>
              <input
                :checked="updated_all_day_checkbox"
                class="ml-2"
                type="checkbox"
                model="updated_all_day_checkbox"
                @change="updatedAllDay"
              />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="!updated_all_day_checkbox">
            <div class="vx-col sm:w-1/3 w-full">
              <span>End</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr
              class="flat-pick"
                :config="configdateTimePicker"
                v-model="update_event_end"
                placeholder="Date Time"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full description">
                          <quill-editor v-model="update_event_description"></quill-editor>

              <!-- <vs-textarea v-model="update_event_description" height="500px" /> -->
            </div>

          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-5 mb-2" @click.prevent="validateBeforeUpdate"
                >Update</vs-button
              >
              <vs-button
                v-if="!event_resize_or_drop"
                class="ml-3 mb-2"
                color="danger"
                @click.prevent="deleteEvent"
                >Delete</vs-button
              >
            </div>
          </div>
        </form>
      </vs-popup>
    </form>

    <form>
      <vs-popup
        fullscreen
        class="holamundo"
        title="Add New Event"
        :active.sync="newEventPopupActive"
      >
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Title</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              class="w-full"
              v-validate="'required'"
              data-vv-as="Title"
              name="new_event_title"
              v-model="new_event_title"
            />
            <span
              class="text-danger text-sm mt-2"
              v-show="errors.has('new_event_title')"
              >{{ errors.first("new_event_title") }}</span
            >
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Start</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <flat-pickr class="flat-pick"
              :config="configdateTimePicker"
              v-model="new_event_start"
              placeholder="Date Time"
            />
            <span class="ml-5">All Day</span>
            <input
              :checked="added_all_day_checkbox"
              class="ml-2"
              type="checkbox"
              model="added_all_day_checkbox"
              @change="addedAllDay"
            />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="!added_all_day_checkbox">
          <div class="vx-col sm:w-1/3 w-full">
            <span>End</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <flat-pickr class="flat-pick"
              :config="configdateTimePicker"
              v-model="new_event_end"
              placeholder="Date Time"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Description</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full description">
            <vs-textarea v-model="new_event_description"/>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click.prevent="validateBeforeSubmit"
              >Submit</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </form>

    <vs-row vs-w="12" class="mb-5">
      <!-- <div class="vx-col sm:w-1/7 w-full">
              <span>Timezone:</span>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <TimezoneAutocomplete
                class="searchbox"
                :list="getTimezones"
                :searchOn="'timezone'"
                @event-name="handleTimeZoneSelected"
              ></TimezoneAutocomplete>
            </div> -->
    </vs-row>

    <!-- <div class='demo-app-sidebar'>
      <div class='demo-app-sidebar-section'>
        <h2>Instructions</h2>
        <ul>
          <li>Select dates and you will be prompted to create a new event</li>
          <li>Drag, drop, and resize events</li>
          <li>Click an event to delete it</li>
        </ul>
      </div>
      <div class='demo-app-sidebar-section'>
        <label>
          <input
            type='checkbox'
            :checked='calendarOptions.weekends'
            @change='handleWeekendsToggle'
          />
          toggle weekends
        </label>
      </div>
      <div class='demo-app-sidebar-section'>
        <h2>All Events ({{ currentEvents.length }})</h2>
        <ul>
          <li v-for='event in currentEvents' :key='event.id'>
            <b>{{ event.startStr }}</b>
            <i>{{ event.title }}</i>
          </li>
        </ul>
      </div>
    </div> -->
    <div class="demo-app-main">
      <FullCalendar
        class="demo-app-calendar"
        ref="calendar"
        :options="calendarOptions"
      >
        <template v-slot:eventContent="arg">
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
  </div>
</template>

<style lang="css">
.flat-pick{
   padding: .7rem;
    border-radius: 5px;
    font-size: 1rem;
    color: #626262;
    cursor: pointer;
}

 
.scheduled,
.scheduled div,
.scheduled span {
  background-color: rgb(230, 216, 216); /* background color */
  border-color:#aa8585; /* border color */
  color: darkblue;
}

.description{
  height: 100%;
}

.quill-editor{
   height: 100%;
}
h2 {
  margin: 0;
  font-size: 16px;
}
ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
}
b {
  /* used for event dates/times */
  margin-right: 3px;
}
.not-available,
.not-available div,
.not-available span {
  background-color: red; /* background color */
  border-color: white; /* border color */
  color: white;
}

.available,
.available div,
.available span {
  background-color: green; /* background color */
  border-color: white; /* border color */
  color: white;
  /* text color */
}
</style>
